<div *ngIf="isVisible" class="one-error-overlay">
    <section
        class="one-error-panel has-error"
        role="alertdialog"
        aria-modal="true"
        [attr.aria-labelledby]="headingId"
        [attr.aria-describedby]="descriptionId"
    >
        <header class="one-error-header">
            <div class="one-error-brand" aria-label="ANAMETA ONE">
                ANAMETA <span>ONE</span>
            </div>
            <div class="one-error-badge">
                <span class="one-error-badge-error" aria-hidden="true">!</span>
                <span>{{ badgeText }}</span>
            </div>
        </header>

        <div class="one-error-intro">
            <div class="one-error-hero-icon one-error-hero-error">
                <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
                    <path d="M12 3 2 20h20L12 3Z"></path>
                    <path d="M12 9v5m0 3h.01"></path>
                </svg>
            </div>
            <h2 [id]="headingId">{{ heading }}</h2>
            <p [id]="descriptionId">{{ subtitle }}</p>
        </div>

        <div class="one-error-error-box" role="alert">
            <span class="one-error-error-label">{{ errorLabel }}</span>
            <p>{{ displayMessage }}</p>
        </div>

        <div class="one-error-error-actions">
            <a
                *ngIf="showHomeButton"
                class="one-error-button one-error-button-secondary"
                [routerLink]="homeUrl"
            >
                {{ homeText }}
            </a>
            <button
                *ngIf="retryEnabled"
                type="button"
                class="one-error-button one-error-button-secondary"
                (click)="Retry()"
            >
                {{ retryText }}
            </button>
            <button
                *ngIf="showLoginButton"
                type="button"
                class="one-error-button one-error-button-primary"
                (click)="GoToLogin()"
            >
                {{ loginText }}
            </button>
        </div>

        <footer class="one-error-footer">
            <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path d="M7 10V7a5 5 0 0 1 10 0v3M5 10h14v11H5V10Zm7 4v3"></path>
            </svg>
            <span>Güvenli bağlantı <span class="one-error-footer-dot">•</span> ANAMETA ONE</span>
        </footer>
    </section>
</div>
